import { ShoppbudAPI } from '@inhouse-market/sdk';
import pkg from '../../package.json';
import env from '../env';

const apiSDK = new ShoppbudAPI({
  appVersion: pkg.version || '',
  async getTokenFn() {
    const authToken = localStorage.getItem('@NeerHouse:assumedToken') || localStorage.getItem('@NeerHouse:token');
    return authToken!;
  },
  platformAndVersion: "admin",
  url: env.API_URL,
  userId: localStorage.getItem('@NeerHouse:userId') || ''
});

export default apiSDK;
